import { Breadcrumb, Container } from 'react-bootstrap';
import { Outlet, Link, useParams } from 'react-router-dom';

const FormResponseLayout = () => {
  const params = useParams();

  const lastBreadcrumbItemProps = {
    active: true
  };

  if (params.formResponseId) {
    const newProps = {
      active: false,
      linkAs: Link,
      linkProps: { to: './' }
    };

    Object.assign(lastBreadcrumbItemProps, newProps);
  }

  return (
    <Container id="form-response" fluid>
      <Breadcrumb>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/forms' }}>
          Formularios
        </Breadcrumb.Item>
        <Breadcrumb.Item {...lastBreadcrumbItemProps}>{params.formTypeId}</Breadcrumb.Item>
      </Breadcrumb>
      <Outlet />
    </Container>
  );
};

export default FormResponseLayout;
